import { LOGIN_PATH, OIDC_CALLBACK_PATH } from "@airange/shared/oidc-routes";

export const coreAdminRoutes = [
  {
    path: LOGIN_PATH,
    layout: false,
    component: "./LoginPage",
  },
  {
    path: OIDC_CALLBACK_PATH,
    layout: false,
    component: "./OidcCallbackPage",
  },
  {
    path: "/",
    redirect: "/dashboard",
  },
  {
    path: "/dashboard",
    name: "dashboard",
    icon: "dashboard",
    access: "canViewDashboard",
    component: "./DashboardPage",
  },
  {
    path: "/applications",
    redirect: "/portal/entries",
  },
  {
    path: "/portal",
    name: "portalManagement",
    icon: "appstore",
    access: "canViewDashboard",
    routes: [
      {
        path: "",
        redirect: "/portal/appearance",
      },
      {
        path: "appearance",
        name: "portalAppearance",
        icon: "skin",
        component: "./PortalAppearancePage",
      },
      {
        path: "groups",
        name: "portalGroups",
        icon: "team",
        component: "./PortalGroupsPage",
      },
      {
        path: "entries",
        name: "portalEntries",
        icon: "appstoreAdd",
        component: "./PortalEntriesPage",
      },
      {
        path: "access",
        name: "portalAccess",
        icon: "safetyCertificate",
        component: "./PortalAccessPage",
      },
      {
        path: "security",
        name: "portalSecurity",
        icon: "securityScan",
        component: "./PortalSecurityPage",
      },
      {
        path: "ui-semantics",
        name: "portalUiSemantics",
        icon: "tags",
        component: "./PortalUiSemanticsPage",
      },
    ],
  },
  {
    path: "/identity",
    name: "identity",
    icon: "team",
    access: "canManageIdentity",
    routes: [
      {
        path: "",
        redirect: "/identity/dashboard",
      },
      {
        path: "dashboard",
        name: "dashboard",
        icon: "dashboard",
        component: "./identity-routes/DashboardPage",
      },
      {
        path: "applications",
        name: "identityApplications",
        icon: "appstore",
        component: "./identity-routes/ApplicationsPage",
      },
      {
        path: "users",
        name: "identityUsers",
        icon: "user",
        component: "./identity-routes/UsersPage",
      },
      {
        path: "tenants",
        name: "identityTenants",
        icon: "bank",
        component: "./identity-routes/TenantsPage",
      },
      {
        path: "organizations",
        name: "identityOrganizations",
        icon: "apartment",
        component: "./identity-routes/OrganizationsPage",
      },
      {
        path: "roles",
        name: "identityRoles",
        icon: "idcard",
        component: "./identity-routes/RolesPage",
      },
      {
        path: "permissions",
        name: "identityPermissions",
        icon: "safetyCertificate",
        component: "./identity-routes/PermissionsPage",
      },
      {
        path: "user-custom-fields",
        name: "identityUserCustomFields",
        icon: "form",
        component: "./identity-routes/UserCustomFieldsPage",
      },
      {
        path: "events",
        name: "identityEvents",
        icon: "history",
        component: "./identity-routes/EventsPage",
      },
      {
        path: "login-records",
        name: "identityLoginRecords",
        icon: "securityScan",
        component: "./identity-routes/LoginRecordsPage",
      },
    ],
  },
  {
    path: "/centers",
    name: "centers",
    icon: "shop",
    access: "canManagePlatform",
    component: "./CentersPage",
  },
];
